import { render, staticRenderFns } from "./surgeryAppointment.vue?vue&type=template&id=e5cd4830&scoped=true&"
import script from "./surgeryAppointment.vue?vue&type=script&lang=js&"
export * from "./surgeryAppointment.vue?vue&type=script&lang=js&"
import style0 from "./surgeryAppointment.vue?vue&type=style&index=0&id=e5cd4830&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5cd4830",
  null
  
)

export default component.exports